import { JMCHtml } from "@components/JMCHtml/JMCHtml";
import { NotificationImpression } from "@jmc/core/src/components/NotificationImpression/NotificationImpression";
import { Banner } from "@jmc/solid-design-system/src/components/atoms/Banner/Banner";
import { ApplicationState } from "@redux/modules";
import { Profile } from "@redux/modules/profile";
import isEqual from "lodash/isEqual";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export const ShowSSOBanner = (): JSX.Element => {
    const [shouldDisplay, setShouldDisplay] = useState(false);
    const [isDissmissed, setIsDissmissed] = useState(false);

    const { t } = useTranslation();
    const profile = useSelector((state: ApplicationState) => state.profile?.data as unknown as Profile, isEqual);

    useEffect(() => {
        const queryString = new URLSearchParams(location.search);
        if (queryString.get("action") === "pingLogin") {
            setShouldDisplay(true);
        }
    }, []);

    return (
        <>
            {shouldDisplay && profile && (
                <NotificationImpression
                    type="action-message"
                    trigger="user-action"
                    name="pingLogin"
                    action={isDissmissed ? "closed" : null}
                >
                    {!isDissmissed && (
                        <Banner
                            id="PingLogin"
                            text={
                                <JMCHtml>
                                    {t(
                                        "As J&J employee, by accessing the JMC site you acknowledge to access only those sites related to your function. If you are a sales representative, you will not navigate Medical Education pages, as this may have HCC implications. Information about which pages were visited, when and by which department will be collected and reported regionally, at aggregate level, by country. You can find out more about how J&J manages your personal data by visiting the Global Employee Notice in SUMMIT. You are logged in with CODSID {{CODSID}}.",
                                        {
                                            ns: "actions",
                                            CODSID: profile?.codsId,
                                        },
                                    )}
                                </JMCHtml>
                            }
                            type="info"
                            showIcon={true}
                            onDismiss={() => setIsDissmissed(true)}
                            dismissText={t("Close", { ns: "common" })}
                        ></Banner>
                    )}
                </NotificationImpression>
            )}
        </>
    );
};

export default ShowSSOBanner;
